import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var VideoOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 12.146v20.547s0 .1.1.1h1.2a1 1 0 0 1 1 .998 1 1 0 0 1-1 .997H2.2c-1.2 0-2.2-.997-2.2-2.194V12.146C0 10.949 1 9.95 2.2 9.95h23.6a1 1 0 0 1 1 .998c0 .498-.5.997-1 .997l-23.7.2c0-.1 0-.1 0 0ZM43.5 11.049c.3.199.5.498.5.897v21.047c0 .399-.2.698-.5.897-.3.2-.7.2-1 0l-9.3-4.688c-.5-.299-.7-.897-.5-1.396.3-.499.9-.698 1.4-.499l7.7 3.89V13.642l-7.7 3.89c-.5.3-1.1.1-1.4-.499-.3-.498-.1-1.097.5-1.396l9.3-4.688c.3-.1.7-.1 1 .1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4 3.069a1.09 1.09 0 0 0-1.5 0L2.6 40.274c-.4.4-.4 1.097 0 1.496.4.4 1.1.4 1.5 0l6.9-6.882h17.5c1.2 0 2.1-.998 2.1-2.195V15.238L41.4 4.565c.4-.399.4-1.097 0-1.496ZM28.6 32.693l-15.5.1 15.5-15.46v15.36Z"
  }));
});
VideoOff.displayName = 'VideoOff';
VideoOff.defaultProps = {
  'aria-label': 'VideoOff'
};
export default VideoOff;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/VideoOff.js
// module id = 3317
// module chunks = 11